import DOMPurify from "dompurify"

// Hooks live on the instance, so this one is isolated from the DOMPurify that
// other callers import and its hook cannot change their output.
const linkSafePurifier = DOMPurify(window)

// IFE builds these anchors with target="_blank" and DOMPurify will not add rel
// itself, which would leave the opened page holding a live window.opener.
linkSafePurifier.addHook("afterSanitizeAttributes", node => {
  if (node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer")
  }
})

// Removes every tag but leaves entities encoded, so the result is still safe to
// hand to a parser when the caller needs those entities decoded. Platform values
// reach us entity encoded because IFE sanitizes them with strip_tags.
export function stripMarkup(value: string) {
  return DOMPurify.sanitize(value, { ALLOWED_TAGS: [] })
}

// Step field text keeps its links, because IFE turns markdown links in that text
// into anchors on purpose. DOMPurify drops any href that is not a safe scheme.
export function stripMarkupKeepingLinks(value: string) {
  return linkSafePurifier.sanitize(value, {
    ALLOWED_TAGS: ["a"],
    ALLOWED_ATTR: ["href", "target", "rel"],
  })
}
